$(function (){
    $('[js-article-gallery]').each(function(i, gallery){
        $$.Pswp($(gallery));
    });
})